export default __webpack_public_path__ + "static/media/buckle.d08c668c.jpg";